import ClaudiaTakeoversAPI from 'dashboard/api/claudiaTakeovers';

const actions = {
  async create(_, { conversationId }) {
    const response = await ClaudiaTakeoversAPI.create({
      conversation_id: conversationId,
    });
    return response.data;
  },
};

export default {
  namespaced: true,
  actions,
};
